var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSabreDeLuz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "250px",
    height: "250px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 45 2 C 44.199219 2 43.445313 2.3125 42.878906 2.878906 L 21 24.757813 L 21 27.585938 L 44.292969 4.292969 C 44.488281 4.097656 44.742188 4 45 4 C 45.257813 4 45.511719 4.097656 45.707031 4.292969 C 46.097656 4.683594 46.097656 5.316406 45.707031 5.707031 L 21 30.414063 L 21 33.242188 L 47.121094 7.121094 C 47.6875 6.554688 48 5.800781 48 5 C 48 4.199219 47.6875 3.445313 47.121094 2.878906 C 46.554688 2.3125 45.800781 2 45 2 Z M 19 26.363281 L 10.675781 34.675781 L 9 33 L 6 36 L 7.675781 37.675781 L 2 43.34375 L 3.328125 44.671875 L 2 46 L 4 48 L 5.328125 46.671875 L 6.65625 48 L 19 35.671875 Z M 17 31.1875 L 17 34.84375 L 16.128906 35.714844 L 14.300781 33.886719 Z M 12.886719 35.296875 L 14.714844 37.125 L 6.65625 45.171875 L 4.828125 43.34375 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSabreDeLuz);
export default __webpack_public_path__ + "static/media/sabreDeLuz.d1ca4dddd0a41f0517d5764d5b89a503.svg";
export { ForwardRef as ReactComponent };